import React, { useContext, useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import ReportContext from "../../../../context/reports/ReportContext";

const ReportSummary = ({ numberFormatter, currencyFormatter }) => {
  const useStyles = makeStyles((theme) => ({
    tableHead: {
      border: "1px solid white",
      color: "white",
      backgroundColor: theme.palette.primary.main,
      textAlign: "center",
      width: "10%",
    },
    tableBody: {
      border: "1px solid #c7c7c7",
      textAlign: "center",
    },
    red: {
      color: "red",
    },
    green: {
      color: "green",
    },
  }));

  const classes = useStyles();

  const {
    date_range,
    reports_loading,
    reports,
    report_type_aureas,
    setReportType,
  } = useContext(ReportContext);

  const [data, setData] = useState([]);

  const onChangeType = () => {
    if (report_type_aureas === "Campaign Analytics") {
      setReportType("Product Analytics");
    } else if (report_type_aureas === "Product Analytics") {
      setReportType("Campaign Analytics");
    }
  };

  useEffect(() => {
    if (reports) {
      let totals = {
        visits: 0,
        clicks: 0,
        conversions: 0,
        revenue: 0,
        cost: 0,
        profit: 0,
        ROAS: 0,
        CTR: 0,
        CV: 0,
        AP: 0,
      };

      // Calculate Totals
      reports.forEach((report) => {
        totals.visits += report.visits;
        totals.clicks += report.clicks;
        totals.conversions += report.conversions;
        totals.revenue += parseFloat(report.revenue);
        totals.cost += parseFloat(report.cost);
        totals.profit += parseFloat(report.profit);
      });

      const dividend = (a, b) => (Number.isFinite(a / b) ? a / b : 0);

      totals.ROAS = dividend(totals.revenue, totals.cost);
      totals.CTR = dividend(totals.clicks, totals.visits) * 100;
      totals.CV = dividend(totals.conversions, totals.clicks) * 100;
      totals.AP = dividend(totals.revenue, totals.conversions);

      // Format Value to 2 Decimals String
      totals.revenue = totals.revenue.toFixed(2);
      totals.cost = totals.cost.toFixed(2);
      totals.profit = totals.profit.toFixed(2);
      totals.ROAS = totals.ROAS.toFixed(2);
      totals.CTR = totals.CTR.toFixed(2);
      totals.CV = totals.CV.toFixed(2);
      totals.AP = totals.AP.toFixed(2);

      setData([totals]);
    }
  }, [reports]);

  return (
    <Grid
      item
      style={{
        marginTop: 5,
      }}
    >
      <TableContainer component={Paper}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{
            padding: "19px 24px",
          }}
        >
          <Grid item>
            <Typography variant="h6"> Summary: {date_range} </Typography>
          </Grid>
          <Grid item>
            <Button variant="outlined" color="primary" onClick={onChangeType}>
              
              {report_type_aureas === "Campaign Analytics"
                ? "Product Analytics"
                : "Campaign Analytics"}
            </Button>
          </Grid>
        </Grid>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}> Visits </TableCell>
              <TableCell className={classes.tableHead}> Clicks </TableCell>
              <TableCell className={classes.tableHead}> Conversions </TableCell>
              <TableCell className={classes.tableHead}> Revenue </TableCell>
              <TableCell className={classes.tableHead}> Cost </TableCell>
              <TableCell className={classes.tableHead}> Profit </TableCell>
              <TableCell className={classes.tableHead}> ROAS </TableCell>
              <TableCell className={classes.tableHead}> CTR </TableCell>
              <TableCell className={classes.tableHead}> CV </TableCell>
              <TableCell className={classes.tableHead}> AP </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!reports_loading && data.length > 0 ? (
              data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tableBody}>                    
                    {numberFormatter.format(row.visits)}
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {numberFormatter.format(row.clicks)}
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {numberFormatter.format(row.conversions)}
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {currencyFormatter.format(row.revenue)}
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {currencyFormatter.format(row.cost)}
                  </TableCell>

                  <TableCell
                    className={clsx(classes.tableBody, {
                      [classes.red]: +row.profit < 0,
                      [classes.green]: +row.profit > 0,
                    })}
                  >
                    {currencyFormatter.format(row.profit)}
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {row.ROAS}
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {row.CTR} %
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {row.CV} %
                  </TableCell>

                  <TableCell className={classes.tableBody}>                   
                    {currencyFormatter.format(row.AP)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} className={classes.tableBody}>
                  No records to display
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default ReportSummary;
